export const WHOLESALE_PRICE_SUFFIX = "price";  // pages that end with this suffix will follow the WHOLESALE PRICE flow
export const THREE_PW = "3pw";
export const NMP = "nike-marketplace-partners";
export const NMP_WHOLESALE = `nike-marketplace-partners-${WHOLESALE_PRICE_SUFFIX}`;
export const NSP = "nike-store-partners";
export const NSP_WHOLESALE = `nike-store-partners-${WHOLESALE_PRICE_SUFFIX}`;
export const NSO = "nike-store-owned";
export const NSP_HYBRID = "nike-store-partners-hybrid";
export const NVS = "nike-value-store";
export const NIKE_DOT_COM = "nike-com";
export const CONSIGNMENT = "3pp-consignment";
export const DROP_SHIP = "3pp-drop-ship";
export const ROUTES = {
  NMP: `/${THREE_PW}-${NMP}`,
  NMP_WHOLESALE: `/${THREE_PW}-${NMP_WHOLESALE}`,
  NSP: `/${THREE_PW}-${NSP}`,
  NSP_WHOLESALE: `/${THREE_PW}-${NSP_WHOLESALE}`,
  STORE_OWNED: `/nso-${NSO}`,
  STORE_HYBRID: `/nso-${NSP_HYBRID}`,
  VALUE_STORE: `/nvs-${NVS}`,
  NIKE_DOT_COM: `/nddc-${NIKE_DOT_COM}`,
  CONSIGNMENT: `/nddc-${CONSIGNMENT}`,
  DROP_SHIP: `/nddc-${DROP_SHIP}`,
};
